class ProLimits{

    constructor() {
        this.brokerAccountsLimit = 3;
        this.assetsInWatchlistLimit = 3;
        this.considerationsLimit = 3;
        this.strategiesLimit = 2;
        this.tradesPerMonthLimit = 10;
    }

    verifyLimitsByBrokerAccounts(current){
        return current < this.brokerAccountsLimit;
    }

    verifyLimitsByAssetsInWatchlist(current){
        return current < this.assetsInWatchlistLimit;
    }

    verifyLimitsByConsiderations(current){
        return current < this.considerationsLimit;
    }

    verifyLimitsByStrategies(current){
        return current < this.strategiesLimit;
    }

    verifyLimitsByTradesPerMonth(current){
        return current < this.tradesPerMonthLimit;
    }
}

export default new ProLimits();
